"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthProvider = void 0;
exports.useAuth = useAuth;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : authContext.js
* Description : Ce fichier contient des variables disponibles partout dans l'application concernant 
*               l'identification de l'utilisateur et ses informations
* Date de création : 30 septembre 2025
*/ /* CSS et assets */ // None
/* Bibliothèques et composants */ // None
/* Hook */
var AuthContext = /*#__PURE__*/(0, _react.createContext)(null);
function useAuth() {
  return (0, _react.useContext)(AuthContext);
}
var AuthProvider = exports.AuthProvider = function AuthProvider(_ref) {
  var children = _ref.children;
  // Define useState hooks
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    authStatus = _useState2[0],
    setAuthStatus = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    authToken = _useState4[0],
    setAuthToken = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    authRefresh = _useState6[0],
    setAuthRefresh = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    currentUserId = _useState8[0],
    setCurrentUserId = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState0 = _slicedToArray(_useState9, 2),
    currentUser = _useState0[0],
    setCurrentUser = _useState0[1];
  var _useState1 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState1, 2),
    authConfirm = _useState10[0],
    setAuthConfirm = _useState10[1];
  var login = function login(status, token, refresh, id) {
    setAuthStatus(status);
    setAuthToken(token);
    setAuthRefresh(refresh);
    setCurrentUserId(id);
  };
  var getCurrentUser = function getCurrentUser(first_name, last_name, username, role, is_active, must_change_password, date_last_password, company) {
    var user_params = {
      "first_name": first_name,
      "last_name": last_name,
      "username": username,
      "role_name": role,
      "is_active": is_active,
      "must_change_password": must_change_password,
      "date_last_password": date_last_password,
      "company": company
    };
    setCurrentUser(user_params);
  };
  var confirmLogin = function confirmLogin(bool) {
    setAuthConfirm(bool);
  };
  var logout = function logout() {
    console.log('logout');
    setAuthStatus(null);
    setAuthToken(null);
    setAuthRefresh(null);
    setCurrentUserId(null);
    setCurrentUser(null);
    setAuthConfirm(null);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(AuthContext.Provider, {
    value: {
      authStatus: authStatus,
      authToken: authToken,
      authRefresh: authRefresh,
      currentUserId: currentUserId,
      currentUser: currentUser,
      authConfirm: authConfirm,
      login: login,
      getCurrentUser: getCurrentUser,
      confirmLogin: confirmLogin,
      logout: logout
    },
    children: children
  });
};